import React from 'react';
import { mapElementClass } from '../../../common/utils/element.utils';
var PagePdf = function (_a) {
    var frontOptions = _a.frontOptions, value = _a.value;
    var frameHeight = frontOptions.height || window.innerHeight - 20;
    return (React.createElement("div", { className: mapElementClass(frontOptions), style: { height: frameHeight } },
        React.createElement("iframe", { title: 'PDF Viewer', src: value, width: "100%", height: '100%' })));
};
export default PagePdf;
//# sourceMappingURL=PagePdf.js.map